import React from 'react';

const BlogSection = () => {
  const featuredArticle = {
    title: 'AI Automation Expert: The Future of Autonomous Enterprise Workflows & Robotics',
    category: 'AI & AUTOMATION EXPERT',
    date: 'August 2026',
    readTime: '5 min read',
    author: 'HungryTop AI Research Team',
    image: '/images/ai-automation-expert.png',
    snippet: 'Explore how next-generation autonomous AI agents, physical-digital robotics, and LLM-driven process automation are revolutionizing enterprise efficiency and workflow execution.',
    deliverables: ['Autonomous AI Agents', 'Process Robotics', 'LLM Workflow Sync'],
  };

  const articles = [
    {
      title: 'Architecting High-Throughput Digital Lending Engines in 2026',
      category: 'FINTECH',
      date: 'August 2026',
      readTime: '6 min read',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80',
      snippet: 'How micro-services and automated e-KYC pipelines enable sub-second credit decisioning for enterprise lenders.',
    },
    {
      title: 'Building Enterprise AI Agents with LLMs and Vector Databases',
      category: 'AI & DATA',
      date: 'July 2026',
      readTime: '8 min read',
      image: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=800&q=80',
      snippet: 'A comprehensive guide on deploying RAG pipelines and domain-specific AI models with high precision.',
    },
    {
      title: 'The Future of Restaurant Commerce & Omnichannel POS Systems',
      category: 'RESTAURANT SAAS',
      date: 'June 2026',
      readTime: '5 min read',
      image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=800&q=80',
      snippet: 'How cloud-native POS architectures synchronize kitchen operations, rider dispatch, and real-time payments.',
    },
  ];

  return (
    <section
      id="blog"
      style={{
        padding: '60px 0 70px 0',
        position: 'relative',
        zIndex: 2,
        background: '#040612',
        color: '#FFFFFF',
        fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      {/* Background Ambient Radial Glows */}
      <div
        style={{
          position: 'absolute',
          top: '20%',
          right: '15%',
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(168, 85, 247, 0.1) 0%, rgba(0,0,0,0) 70%)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '20%',
          left: '15%',
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(56, 189, 248, 0.1) 0%, rgba(0,0,0,0) 70%)',
          pointerEvents: 'none',
        }}
      />

      <div className="ht-container" style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 16px',
              borderRadius: '20px',
              background: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              fontSize: '0.72rem',
              fontWeight: 700,
              letterSpacing: '1.2px',
              color: '#D8B4FE',
              marginBottom: '14px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
            }}
          >
            <span style={{ fontSize: '0.8rem' }}>🤖</span>
            <span>AI INSIGHTS & AUTOMATION</span>
          </div>

          <h2
            style={{
              fontSize: 'clamp(2.1rem, 4vw, 3rem)',
              fontWeight: 800,
              letterSpacing: '-0.03em',
              margin: '0 0 12px 0',
              lineHeight: 1.15,
            }}
          >
            <span style={{ color: '#FFFFFF' }}>Latest Thoughts on </span>
            <span
              style={{
                background: 'linear-gradient(90deg, #A78BFA 0%, #38BDF8 50%, #818CF8 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              AI, SaaS & Engineering
            </span>
          </h2>

          <p
            style={{
              color: '#94A3B8',
              fontSize: '0.96rem',
              maxWidth: '650px',
              margin: '0 auto',
              lineHeight: 1.5,
              fontWeight: 400,
            }}
          >
            Deep-dive technical articles written by Hungry Top Technologies AI automation experts & engineering leaders.
          </p>
        </div>

        {/* ======================================================== */}
        {/* FEATURED SPOTLIGHT ARTICLE: AI AUTOMATION EXPERT */}
        {/* ======================================================== */}
        <div
          className="blog-featured-card"
          style={{
            background: 'linear-gradient(145deg, rgba(15, 17, 36, 0.9) 0%, rgba(9, 11, 25, 0.95) 100%)',
            borderRadius: '24px',
            border: '1px solid rgba(168, 85, 247, 0.4)',
            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5), 0 0 30px rgba(168, 85, 247, 0.15)',
            marginBottom: '32px',
            overflow: 'hidden',
            display: 'grid',
            gridTemplateColumns: '1.1fr 1fr',
            gap: '0',
            alignItems: 'stretch',
            position: 'relative',
          }}
        >
          {/* Top Glow Accent Line */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '2px',
              background: 'linear-gradient(90deg, transparent 0%, #A78BFA 50%, transparent 100%)',
            }}
          />

          {/* Left Content Area */}
          <div style={{ padding: '36px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              {/* Category Pill & Date */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <span
                  style={{
                    background: 'rgba(168, 85, 247, 0.15)',
                    border: '1px solid rgba(168, 85, 247, 0.4)',
                    color: '#E9D5FF',
                    fontSize: '0.68rem',
                    fontWeight: 800,
                    padding: '5px 12px',
                    borderRadius: '20px',
                    letterSpacing: '0.8px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  <span style={{ fontSize: '0.75rem' }}>🤖</span>
                  {featuredArticle.category}
                </span>

                <span style={{ fontSize: '0.76rem', color: '#94A3B8', fontWeight: 600 }}>
                  {featuredArticle.date} • {featuredArticle.readTime}
                </span>
              </div>

              {/* Title */}
              <h3
                style={{
                  fontSize: 'clamp(1.4rem, 2.5vw, 1.85rem)',
                  fontWeight: 800,
                  color: '#FFFFFF',
                  lineHeight: 1.25,
                  margin: '0 0 14px 0',
                  letterSpacing: '-0.02em',
                }}
              >
                {featuredArticle.title}
              </h3>

              {/* Snippet */}
              <p
                style={{
                  fontSize: '0.9rem',
                  color: '#94A3B8',
                  lineHeight: 1.6,
                  margin: '0 0 20px 0',
                }}
              >
                {featuredArticle.snippet}
              </p>

              {/* Deliverable Tags */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '24px' }}>
                {featuredArticle.deliverables.map((item, i) => (
                  <span
                    key={i}
                    style={{
                      padding: '4px 10px',
                      borderRadius: '8px',
                      background: 'rgba(255, 255, 255, 0.04)',
                      border: '1px solid rgba(168, 85, 247, 0.3)',
                      color: '#CBD5E1',
                      fontSize: '0.74rem',
                      fontWeight: 600,
                    }}
                  >
                    ✓ {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Bottom Actions Row */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <a
                href="#blog"
                style={{
                  background: 'linear-gradient(90deg, #7C3AED 0%, #6366F1 100%)',
                  boxShadow: '0 4px 18px rgba(124, 58, 237, 0.35)',
                  borderRadius: '30px',
                  color: '#FFFFFF',
                  padding: '10px 22px',
                  fontSize: '0.82rem',
                  fontWeight: 700,
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <span>Read Full Article</span>
                <span style={{ fontSize: '0.9rem' }}>→</span>
              </a>

              <span style={{ fontSize: '0.74rem', color: '#64748B', fontWeight: 600 }}>
                By {featuredArticle.author}
              </span>
            </div>
          </div>

          {/* Right Image Container */}
          <div style={{ position: 'relative', overflow: 'hidden', minHeight: '300px', background: '#0B0F24' }}>
            <img
              src={featuredArticle.image}
              alt="AI Automation Expert"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
              }}
            />

            {/* Gradient Overlay */}
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(90deg, rgba(9, 11, 25, 0.7) 0%, transparent 60%)',
                pointerEvents: 'none',
              }}
            />

            {/* Bottom Floating Badge Overlay matching user's image style */}
            <div
              style={{
                position: 'absolute',
                bottom: '16px',
                left: '16px',
                background: 'rgba(6, 9, 24, 0.88)',
                backdropFilter: 'blur(8px)',
                borderRadius: '12px',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                padding: '8px 14px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <div
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '10px',
                  background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.1rem',
                  boxShadow: '0 0 12px rgba(245, 158, 11, 0.4)',
                }}
              >
                🤖
              </div>
              <div>
                <div style={{ fontSize: '0.76rem', color: '#FFFFFF', fontWeight: 800 }}>AI Automation Expert</div>
                <div style={{ fontSize: '0.62rem', color: '#34D399', fontWeight: 600 }}>● Active Robotics Agent</div>
              </div>
            </div>
          </div>
        </div>

        {/* ======================================================== */}
        {/* 3-COLUMN ARTICLES GRID */}
        {/* ======================================================== */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '22px',
          }}
          className="blog-grid-layout"
        >
          {articles.map((post, idx) => (
            <div
              key={idx}
              className="blog-card-hover"
              style={{
                background: 'linear-gradient(145deg, rgba(14, 18, 38, 0.9) 0%, rgba(8, 11, 24, 0.95) 100%)',
                borderRadius: '20px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                boxShadow: '0 12px 30px rgba(0, 0, 0, 0.4)',
              }}
            >
              <div>
                {/* Cover Image */}
                <div style={{ position: 'relative', height: '170px', overflow: 'hidden' }}>
                  <img
                    src={post.image}
                    alt={post.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.85)' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '12px',
                      left: '12px',
                      background: 'rgba(6, 8, 22, 0.85)',
                      backdropFilter: 'blur(8px)',
                      color: '#38BDF8',
                      fontSize: '0.62rem',
                      fontWeight: 800,
                      padding: '4px 10px',
                      borderRadius: '10px',
                      border: '1px solid rgba(56, 189, 248, 0.3)',
                      letterSpacing: '0.8px',
                    }}
                  >
                    {post.category}
                  </span>
                </div>

                {/* Article Info */}
                <div style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', gap: '8px', color: '#64748B', fontSize: '0.74rem', marginBottom: '8px', fontWeight: 600 }}>
                    <span>{post.date}</span>
                    <span>•</span>
                    <span>{post.readTime}</span>
                  </div>
                  <h4 style={{ fontSize: '1.08rem', color: '#FFFFFF', marginBottom: '10px', fontWeight: 800, lineHeight: 1.35 }}>
                    {post.title}
                  </h4>
                  <p style={{ fontSize: '0.82rem', color: '#94A3B8', lineHeight: 1.5, margin: 0 }}>
                    {post.snippet}
                  </p>
                </div>
              </div>

              {/* Bottom Read Action */}
              <div style={{ padding: '0 20px 20px 20px' }}>
                <a
                  href="#blog"
                  style={{
                    color: '#A855F7',
                    fontWeight: 700,
                    fontSize: '0.82rem',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  <span>Read Article</span>
                  <span style={{ fontSize: '0.9rem' }}>→</span>
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Embedded Responsive Styles */}
      <style>{`
        .blog-card-hover, .blog-featured-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .blog-card-hover:hover, .blog-featured-card:hover {
          transform: translateY(-4px);
        }
        @media (max-width: 1024px) {
          .blog-featured-card {
            grid-template-columns: 1fr !important;
          }
          .blog-grid-layout {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 640px) {
          .blog-grid-layout {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default BlogSection;
